export default {"src":"/_next/static/media/lifi.756df39b.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};